import React from 'react';
import cn from 'classnames';

import styles from './Tabs.module.scss';

export interface ITabItem<T extends string> {
    id: T,
    label: string,
    count?: number,
}

interface ITabsProps<T extends string> {
    items: ITabItem<T>[],
    activeId: T,
    // eslint-disable-next-line no-unused-vars
    onChange: (id: T) => void,
    className?: string,
}

function Tabs<T extends string>({items, activeId, onChange, className}: ITabsProps<T>) {
    return (
        <div className={cn(styles.container, className)} role="tablist">
            {items.map(({id, label, count}) => (
                <button
                    key={id}
                    type="button"
                    role="tab"
                    aria-selected={id === activeId}
                    className={cn(styles.tab, {[styles.active]: id === activeId})}
                    onClick={() => onChange(id)}
                >
                    {label}
                    {Boolean(count) && <span className={styles.count}>{count}</span>}
                </button>
            ))}
        </div>
    );
}

export default Tabs;
